import React from 'react';
import styled from '@emotion/styled';
import comingImg from 'views/Aide/assets/coming.png';
import { useTranslate } from '@tolgee/react';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    height: 212px;
  }
  .title {
    color: #515359;
    margin-top: 24px;
  }
  .desc {
    color: #84868c;
    margin-top: 6px;
  }
`;
const Analysis = () => {
  const { t } = useTranslate();

  return (
    <Container>
      <img src={comingImg} alt="coming" />
      <div className="title">{t('ViewDashboard.更多数据分析功能')}</div>
      <div className="desc">{t('ViewDashboard.即将上线')}</div>
    </Container>
  );
};

export default Analysis;
